export default __webpack_public_path__ + "31053051cdfa24503f7aa79524c88d2c.svg";